"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeGet = themeGet;

var _themeGet = require("@styled-system/theme-get");

// This file has been autogenerated. Do not modify directly!
function themeGet(path, defaultValue) {
  return function drill(props) {
    return (0, _themeGet.themeGet)(path, defaultValue)(props);
  };
}